import angular from 'angular';

angular.module('cloudX').filter('naceCodeName', ['dataCache', naceCodeName]);

function naceCodeName(dataCache) {
  return function(code) {
    const naceCodeEntry = dataCache.getArray('naceCodes').find(x => x.Code === code);
    return naceCodeEntry?.Name ?? 'Unknown';
  };
}
